import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '@max/shared/base-service/base-api.service';
import { AircraftRegistrationHistoryCollectionModel } from '../models/aircraft-registration-history-collection.model';

@Injectable()
export class AircraftRegistrationService extends BaseApiService {
    public getAircraftRegistrationHistory = (aircraftId: number): Observable<{ result: AircraftRegistrationHistoryCollectionModel[] }> => this.get(`Aircraft/AircraftRegistration/History/${aircraftId}`);

    public updateAircraftRecordStatus = (aircraftRecordId: number, aircraftRecordStatusTypeId: number): Observable<any> => this.post(`Aircraft/AircraftRegistration/Record/${aircraftRecordId}/Status`, aircraftRecordStatusTypeId);

    public getAircraftRecord = (aircraftRecordId: number): Observable<any> => this.get(`Aircraft/AircraftRegistration/Record/${aircraftRecordId}`);

    public getCurrentEffectiveRegistration = (aircraftId: number): Observable<any> => this.get(`Aircraft/AircraftRegistration/CurrentEffective/${aircraftId}`);

    public getRegistrationsByAircraftRecordId = (aircraftRecordId: number): Observable<any> => this.get(`Aircraft/AircraftRegistration/AircraftRecord/${aircraftRecordId}`);
}
